module.exports = __webpack_public_path__ + "img/Beastmaster.85b37d90.jpg";